import React from 'react';
import PropTypes from 'prop-types';
import Popover from 'widgets/Popover';
import Button from 'widgets/Button';
import ReactCountryFlag from 'react-country-flag';
import colors from 'assets/styles/jsVariables/colors';
import { getCountries } from 'libs/geographicalRegion';
import Icon from 'components/Icon';
import CountryItem from './CountryItem';
import './CountryDrop.scss';

const countries = getCountries();

const styles = {
  buttonStyle: {
    height: 48,
    paddingLeft: 9,
    paddingRight: 9,
    '&:hover': {
      background: 'none'
    },
    '@media (max-width: 1023px)': {
      paddingRight: 0
    },
    '@media (max-width: 767px)': {
      minWidth: '30px'
    }
  },
  PopoverStyle: {
    borderRadius: '2px',
    boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px'
  },
  ListItemStyle: {
    '&:hover': {
      backgroundColor: colors.lightestGrey
    }
  }
};

export default class CountryDrop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopover: false
    };
  }

  handleCountrySelect = (country) => {
    this.props.handleCountrySelect(country);
    this.handleRequestClose();
  }

  handleButtonClick = (event) => {
    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestClose = () => {
    this.setState({
      openPopover: false
    });
  }

  render() {
    const { openPopover, anchorEl } = this.state;
    const { selectedCountry } = this.props;
    return (
      <div className="CountryDrop">
        {
          selectedCountry.countryCode &&
          <ReactCountryFlag
            code={selectedCountry.countryCode}
            svg
          />
        }
        <Button
          onClick={this.handleButtonClick}
          cssStyles={{ root: styles.buttonStyle }}
        >
          <div>
            <div
              className="CountryDrop__SelectedCountry__Text"
            >
              {selectedCountry.countryName}
            </div>
            <Icon
              name={openPopover ? 'chevron-up' : 'chevron-down'}
              fill={colors.mediumGrey}
              style={{
                height: 16,
                width: 16,
                marginBottom: -2,
                marginLeft: 10
              }}
            />
          </div>
        </Button>
        <Popover
          open={openPopover}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          onClose={this.handleRequestClose}
          elevation={2}
          cssStyles={{ paper: styles.PopoverStyle }}
          PaperProps={{
            style: {
              maxHeight: '200px',
              maxWidth: '262px',
              borderRadius: '10px',
              marginTop: '25px'
            }
          }}
          style={{ zIndex: 1302 }}
        >
          <div style={{ position: 'relative' }}>
            {
              countries.map((country) => {
                const countryName = Object.keys(country)[0];
                const countryCode = country[countryName];
                return (
                  <CountryItem
                    key={countryCode}
                    countryCode={countryCode}
                    countryName={countryName}
                    onClick={this.handleCountrySelect}
                  />
                );
              })
            }
          </div>
        </Popover>
      </div>
    );
  }
}

CountryDrop.propTypes = {
  selectedCountry: PropTypes.object,
  handleCountrySelect: PropTypes.func
};

CountryDrop.defaultProps = {
  selectedCountry: {
    countryCode: 'US',
    countryName: 'United States'
  },
  handleCountrySelect: () => {}
};




// WEBPACK FOOTER //
// ./src/components/CountryDrop/CountryDrop.jsx